module.exports = __webpack_public_path__ + "img/payment_pc_06.6077210f.png";